import React, { useContext } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { TextField } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withVerticalAlignCenterSpan, ErrorString, getNameErrorMsg, validateName, checkShouldShowError, checkShouldShowErrors, Errors } from '../utils/shared';

const maxLength = 128;

export const isCampaignNameValid = name => validateName({ name, maxLength }) == null;

export const defaultName = undefined;

export const CampaignName = React.memo((props) => {
  const {
    name,
    setName,
  } = props;
  const i18n = useContext(I18nContext);
  const campaingNameText = i18n.getString(_TL_('Campaign name'));
  const error = name.error ? name.error : getNameErrorMsg({ code: validateName({ name: name.value, maxLength }), i18n, maxLength });
  const shouldShowError = checkShouldShowError(name);
  return (
    <div className={classnames('campaign-name', 'section')}>
      <TextField
        label={campaingNameText}
        placeholder={i18n.getString(_TL_('Enter a name for your campaign'))}
        value={name.value}
        onRenderLabel={withVerticalAlignCenterSpan(() => (<HelpPopup
          topic="pop_BA_CampaignCreate_Settings_CampaignName"
          aria-label={i18n.getString(_TL_('Click to learn more about {{item}}'), { item: campaingNameText })}
        />))}
        onChange={(e, value) => {
          setName({
            value,
            isDirty: true,
            isInvalid: isCampaignNameValid(value) !== true,
          });
        }}
        styles={{ fieldGroup: { width: 461, marginTop: '8px' } }}
      />
      {shouldShowError && error && <ErrorString error={error} />}
      {checkShouldShowErrors(name) && <Errors errors={name.errors.map(x => x.message)} />}
    </div>
  );
});

CampaignName.propTypes = {
  name: PropTypes.shape({}),
  setName: PropTypes.func.isRequired,
};

CampaignName.defaultProps = {
  name: {
    value: undefined,
    isDirty: false,
    isInvalid: false,
  },
};
